import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";

import lessonServices from "../../../services/lessonServices";
import Button from "../../Button";
import Modal from "../../Modal";

const ProjectStepsModal = forwardRef(({}, ref) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [projectData, setProjectData] = useState(null);
  const [lessonId, setLessonId] = useState(null);
  const [lessonName, setlessonName] = useState(null);

  useImperativeHandle(ref, () => ({
    openModal(projectData) {
      setLessonId(projectData?.lessonID);
      setlessonName(projectData?.lessonName);
      setIsOpen(true);
    },
    closeModal() {
      setIsOpen(false);
    },
  }));

  const handleCloseModal = () => {
    setIsOpen(false);
  };

  const getProjectSteps = async () => {
    try {
      const response = await lessonServices.getLessonSteps(lessonId);
      setProjectData(response);
      console.log("Project Steps Data:", response);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isOpen) {
      getProjectSteps();
    }
  }, [isOpen]);

  return (
    <Modal
      footer={
        <div className="flex justify-end">
          <Button color="white" variant="outlined" onClick={handleCloseModal} label={t("close")} />
        </div>
      }
      header={<h2 className="text-2xl font-semibold text-blue-500">{lessonName}</h2>}
      isOpen={isOpen}
      onClose={handleCloseModal}
    >
      <div className="space-y-6 p-6">
        <div className="space-y-4">
          {/* Project Steps */}
          <div className="space-y-4">
            {projectData?.map((step) => (
              <div key={step.id} className="border-b pb-4">
                <h3 className="text-xl font-semibold text-gray-800">{step.title}</h3>
                {step.hints && (
                  <ul className="mt-2 list-inside space-y-2">
                    {step.hints.map((hint, index) => (
                      <li
                        key={index}
                        className="text-gray-600"
                        dangerouslySetInnerHTML={{ __html: hint.text }}
                      />
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
});

export default ProjectStepsModal;
